import styled from '@emotion/styled';

const ContentTile = styled.div`
  display: flex;
  background: #000000;
  flex: 1 1 auto;
  border-radius: 5px;
  aspect-ratio: 4/3;
  overflow: hidden;
  max-width: 100%;

  & > video {
    display: block;
    margin: auto;
    border-radius: 5px;
    width: 100%;
    max-width: 100%;
    height: 100%;
  }
`;

export default ContentTile;
